(() => {
  if (window.__sssRingGiftUpsellLoaded) return;
  window.__sssRingGiftUpsellLoaded = true;

  const RING_HANDLE = 'tiktok-mystery-ring-bundle';
  const GIFT_HANDLE = 'gift-ball-add-on';
  const GIFT_VARIANTS = [
    { id: 44097842741338, title: '+3 Gift Balls' },
    { id: 44097842774106, title: '+5 Gift Balls' },
    { id: 44097842806874, title: '+10 Gift Balls' },
  ];

  let giftProduct = null;
  let upsellTimer = null;
  let productRefreshQueued = false;
  let productObserver = null;

  const cartUrl = () => `${window.routes?.cart_url || '/cart'}.js`;
  const cartAddUrl = () => window.routes?.cart_add_url || '/cart/add';
  const money = (cents) => `$${(Number(cents || 0) / 100).toFixed(2)}`;
  const isRingPage = () =>
    window.location.pathname.includes(`/products/${RING_HANDLE}`) ||
    Boolean(document.querySelector(`product-info[data-url*="/products/${RING_HANDLE}"]`));

  const refreshProductControls = () => {
    if (productRefreshQueued) return;
    productRefreshQueued = true;
    queueMicrotask(() => {
      productRefreshQueued = false;
      enhanceProductOptions();
    });
  };

  const refreshUpsellSoon = () => {
    window.clearTimeout(upsellTimer);
    upsellTimer = window.setTimeout(renderGiftBallUpsell, 120);
  };

  const fetchCart = async () => {
    const response = await fetch(cartUrl(), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart could not be loaded.');
    return response.json();
  };

  const fetchGiftProduct = async () => {
    if (giftProduct) return giftProduct;
    const response = await fetch(`/products/${GIFT_HANDLE}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Gift Ball add-on is not available yet.');
    giftProduct = await response.json();
    return giftProduct;
  };

  const cartHasRing = (cart) =>
    cart.items.some((item) => item.handle === RING_HANDLE || item.product_handle === RING_HANDLE);

  const cartGiftVariantIds = (cart) =>
    new Set(
      cart.items
        .filter((item) => item.handle === GIFT_HANDLE || item.product_handle === GIFT_HANDLE)
        .map((item) => Number(item.variant_id))
    );

  const giftVariant = (product, fallback) =>
    product.variants.find((variant) => Number(variant.id) === fallback.id) ||
    product.variants.find((variant) => variant.title === fallback.title.replace('+', '').trim()) ||
    fallback;

  const buildUpsell = (cart, product) => {
    const addedIds = cartGiftVariantIds(cart);
    const state = GIFT_VARIANTS.map((variant) => `${variant.id}:${addedIds.has(variant.id) ? 1 : 0}`).join('|');
    const wrapper = document.createElement('div');
    wrapper.id = 'SssGiftBallUpsell';
    wrapper.className = 'sss-gift-ball-upsell';
    wrapper.dataset.state = state;
    wrapper.innerHTML = `
      <h3 class="sss-gift-ball-upsell__title">Make it extra fun</h3>
      <p class="sss-gift-ball-upsell__copy">Each Gift Ball may include a surprise everyday item, accessory, stationery, or other small gift.</p>
      <div class="sss-gift-ball-upsell__options"></div>
      <p class="sss-gift-ball-upsell__error" role="alert" hidden></p>
    `;

    const options = wrapper.querySelector('.sss-gift-ball-upsell__options');
    GIFT_VARIANTS.forEach((fallback) => {
      const variant = giftVariant(product, fallback);
      const id = Number(variant.id || fallback.id);
      const isAdded = addedIds.has(id);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `sss-gift-ball-upsell__button${isAdded ? ' is-added' : ''}`;
      button.dataset.variantId = String(id);
      button.disabled = isAdded || variant.available === false;
      button.innerHTML = `
        <span>${fallback.title}</span>
        <span class="sss-gift-ball-upsell__price">${
          isAdded ? 'Added' : variant.available === false ? 'Sold out' : money(variant.price)
        }</span>
      `;
      options.append(button);
    });

    return wrapper;
  };

  async function renderGiftBallUpsell() {
    const drawerFooter = document.querySelector('#CartDrawer .drawer__footer');
    const cartPageCtas = document.querySelector('#main-cart-footer .cart__ctas');
    const existing = document.getElementById('SssGiftBallUpsell');
    if (!drawerFooter && !cartPageCtas) return;

    try {
      const cart = await fetchCart();
      if (!cartHasRing(cart)) {
        existing?.remove();
        return;
      }

      const next = buildUpsell(cart, await fetchGiftProduct());
      if (existing?.dataset.state === next.dataset.state) return;
      if (existing) existing.replaceWith(next);
      else (drawerFooter || cartPageCtas).insertAdjacentElement('beforebegin', next);
    } catch (error) {
      existing?.remove();
      console.warn(error);
    }
  }

  async function addGiftBall(button) {
    const upsell = button.closest('.sss-gift-ball-upsell');
    const error = upsell?.querySelector('.sss-gift-ball-upsell__error');
    const price = button.querySelector('.sss-gift-ball-upsell__price');
    const oldPrice = price?.textContent;

    button.disabled = true;
    if (price) price.textContent = 'Adding...';
    if (error) error.hidden = true;

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer
        ? cartDrawer.getSectionsToRender().map((section) => section.id)
        : ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(button.dataset.variantId),
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const parsed = await response.json();
      if (!response.ok || parsed.status) throw new Error(parsed.description || 'Could not add Gift Balls.');

      if (cartDrawer && parsed.sections) cartDrawer.renderContents(parsed);
      else if (window.location.pathname.includes('/cart')) {
        window.location.reload();
        return;
      }

      refreshUpsellSoon();
    } catch (addError) {
      button.disabled = false;
      if (price) price.textContent = oldPrice || 'Try again';
      if (error) {
        error.textContent = addError.message;
        error.hidden = false;
      }
    }
  }

  const cleanLabelText = (label) => {
    const clone = label.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .label-unavailable').forEach((node) => node.remove());
    return clone.textContent
      .replace(/Variant sold out or unavailable/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const splitLabel = (value) => {
    const match = value.match(/^(.+?)\s*\((.+)\)$/);
    return match ? { title: match[1], sub: match[2] } : { title: value, sub: '' };
  };

  const giftTextForQuantity = (title) => {
    if (title.includes('20 Capsules')) return 'Free Big Ring Box + Shell Ring Box';
    if (title.includes('10 Capsules') || title.includes('15 Capsules')) return 'Free Shell Ring Box';
    return 'No bonus gift included';
  };

  const updateOptionTitle = (container, title) => {
    const heading = container.querySelector('legend, .form__label');
    if (!heading) return;
    heading.textContent = title;
    heading.classList.add('sss-ring-option-title');
  };

  const enhanceQuantity = (container) => {
    const labels = [...container.querySelectorAll('input[type="radio"] + label')];
    if (!labels.length) return;
    container.classList.add('sss-ring-quantity-enhanced');
    updateOptionTitle(container, 'Choose your capsule bundle');
    if (labels.every((label) => label.querySelector('.sss-ring-quantity-title'))) return;
    labels.forEach((label) => {
      const original = cleanLabelText(label);
      const { title, sub } = splitLabel(original);
      const badge = title.includes('10 Capsules') ? 'POPULAR' : title.includes('20 Capsules') ? 'BEST VALUE' : '';
      label.innerHTML = `
        ${badge ? `<span class="sss-ring-quantity-badge">${badge}</span>` : ''}
        <span class="sss-ring-quantity-title">${title}</span>
        ${sub ? `<span class="sss-ring-quantity-sub">${sub}</span>` : ''}
        <span class="sss-ring-quantity-gift">${giftTextForQuantity(title)}</span>
      `;
    });
  };

  const enhanceVideo = (container) => {
    const labels = [...container.querySelectorAll('input[type="radio"] + label')];
    if (!labels.length) return;
    container.classList.add('sss-ring-video-enhanced');
    updateOptionTitle(container, 'Want a packing video?');
    if (labels.every((label) => label.querySelector('.sss-ring-video-title'))) return;
    labels.forEach((label) => {
      const original = cleanLabelText(label);
      const isNoVideo = /No Packing Video|No video/i.test(original);
      label.innerHTML = `
        <span class="sss-ring-video-title">${isNoVideo ? 'No video' : 'Film my order'}</span>
        <span class="sss-ring-video-sub">${isNoVideo ? 'Ships sooner' : 'Allow 1 to 2 weeks'}</span>
      `;
    });
  };

  const enhanceSpecialRequest = (container) => {
    const labels = [...container.querySelectorAll('input[type="radio"] + label')];
    if (!labels.length) return;
    container.classList.add('sss-ring-request-enhanced');
    updateOptionTitle(container, 'Special requests');
    if (labels.every((label) => label.querySelector('.sss-ring-request-title'))) return;
    labels.forEach((label) => {
      const original = cleanLabelText(label);
      label.innerHTML = `<span class="sss-ring-request-title">${original}</span>`;
    });
  };

  const chooseDefault = (container) => {
    const defaults = ['No add-on', 'Shell Ring Box', 'No special requests', 'No Special Request'];
    const radio = [...container.querySelectorAll('input[type="radio"]')].find((input) =>
      defaults.some((value) => input.value.trim().toLowerCase() === value.toLowerCase())
    );
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const select = container.querySelector('select');
    if (!select) return;
    const option = [...select.options].find((item) =>
      defaults.some((value) => [item.value, item.textContent].some((text) => text.trim().toLowerCase() === value.toLowerCase()))
    );
    if (option && select.value !== option.value) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  function enhanceProductOptions() {
    if (!isRingPage()) return;

    document.querySelectorAll('.product-form__input').forEach((container) => {
      const title = (container.querySelector('legend, .form__label')?.textContent || '').trim();
      const values = [...container.querySelectorAll('input[type="radio"], option')].map(
        (item) => item.value || item.textContent
      );
      const isQuantity = values.some((value) => /5 Capsules|10 Capsules|15 Capsules|20 Capsules/i.test(value));
      const isVideo = /Packing Video|Packing video/i.test(title) || values.some((value) => /Packing Video|No video/i.test(value));
      const isSpecialRequest = /Special Request|Special requests/i.test(title);
      const shouldHide = /Gift Ball|add-on|Bonus Gift/i.test(title);

      if (isQuantity) enhanceQuantity(container);
      if (isVideo) enhanceVideo(container);
      if (isSpecialRequest) enhanceSpecialRequest(container);
      if (shouldHide) {
        chooseDefault(container);
        container.hidden = true;
        container.style.display = 'none';
      }
    });
  }

  const observeProductArea = () => {
    if (!isRingPage()) return;
    const target = document.querySelector('main') || document.body;
    if (!target || productObserver?.target === target) return;

    productObserver?.disconnect();
    productObserver = new MutationObserver((mutations) => {
      const hasProductUpdate = mutations.some((mutation) =>
        [...mutation.addedNodes].some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return (
            node.matches?.('.product-form__input, variant-selects, product-info') ||
            node.querySelector?.('.product-form__input, variant-selects, product-info')
          );
        })
      );
      if (hasProductUpdate) refreshProductControls();
    });
    productObserver.target = target;
    productObserver.observe(target, { childList: true, subtree: true });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.sss-gift-ball-upsell__button');
    if (button && !button.disabled) addGiftBall(button);
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest?.('.product-form__input, variant-selects')) refreshProductControls();
  });

  document.addEventListener('DOMContentLoaded', () => {
    enhanceProductOptions();
    observeProductArea();
    renderGiftBallUpsell();
    const drawer = document.querySelector('#CartDrawer');
    if (drawer) new MutationObserver(refreshUpsellSoon).observe(drawer, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', () => {
    enhanceProductOptions();
    observeProductArea();
    refreshUpsellSoon();
  });
})();
